<template>
  <b-container fluid>
    <b-button v-b-modal.cover-select-modal class="btn-block cover-print-btn">
      พิมพ์รายงานสรุป
    </b-button>
    <b-modal
      id="cover-select-modal"
      ref="coverSelectModal"
      centered
      hide-footer
      title="กรองข้อมูลสรุปรายงาน"
      size="lg"
    >
      <b-container fluid>
        <div v-if="isLoading" class="loading">
          <b-spinner type="grow" label="Spinning" />
        </div>
        <b-row>
          <!-- <b-col class="p-0">
                        <b-button size="lg" class="cover-btn distance btn-block">
                            แยกตามเส้นทาง
                        </b-button>
                    </b-col>
                    <b-col class="p-0">
                        <b-button size="lg" class="cover-btn corporation btn-block">
                            แยกตามบริษัท
                        </b-button>
          </b-col>-->
          <b-col cols="auto" class="px-1px my-1">
            <date-picker
              v-model="filter.dateRange"
              type="datetime"
              range
            ></date-picker>
            <!-- <div
              class="datepicker-trigger input-group"
              style="min-width: 150px;"
              @mouseover="activeCloseDate = true"
              @mouseleave="activeCloseDate = false"
            >
              <input
                id="datepicker-trigger-summary-modal"
                class="form-control border-right-0"
                type="text"
                autocomplete="off"
                placeholder="Select dates"
                :value="formatDates(filter.dateOne, filter.dateTwo)"
              />
              <div class="input-group-prepend bg-white">
                <span
                  id="basic-addon1"
                  class="input-group-text border-left-0 rounded-right bg-white"
                  ><fa-icon
                    v-show="activeCloseDate"
                    :icon="['fas', 'times']"
                    class="icon"
                    @click="clearDate"
                  />
                </span>
              </div>

              <AirbnbStyleDatepicker
                :trigger-element-id="'datepicker-trigger-summary-modal'"
                :mode="'range'"
                :show-shortcuts-menu-trigger="false"
                :fullscreen-mobile="true"
                :date-one="filter.dateOne"
                :date-two="filter.dateTwo"
                @date-one-selected="
                  (val) => {
                    filter.dateOne = val;
                  }
                "
                @date-two-selected="
                  (val) => {
                    filter.dateTwo = val;
                  }
                "
              />
            </div> -->
          </b-col>
          <b-col cols="auto" class="px-1px my-1">
            <b-dropdown
              id="dropdown-1"
              text="สถานะการพิมพ์"
              variant="secondary"
              class="m-auto"
            >
              <b-form-group>
                <b-form-checkbox
                  v-for="x in statusPrint"
                  :key="x.name"
                  v-model="filter.is_printed"
                  :value="x.value"
                  name="status-print-filter"
                  stacked
                  class="mx-3 my-2"
                >
                  {{ x.name }}
                </b-form-checkbox>
              </b-form-group>
            </b-dropdown>
          </b-col>
          <b-col cols="auto" class="px-1px my-1">
            <b-dropdown
              id="dropdown-1"
              text="สถานะการส่ง"
              variant="secondary"
              class="m-auto"
            >
              <b-form-group>
                <b-form-checkbox
                  v-for="x in statusShared"
                  :key="x.name"
                  v-model="filter.is_shared"
                  :value="x.value"
                  name="status-shared-filter"
                  stacked
                  class="mx-3 my-2"
                >
                  {{ x.name }}
                </b-form-checkbox>
              </b-form-group>
            </b-dropdown>
          </b-col>
          <b-col cols="auto" class="px-1px my-1">
            <b-dropdown
              id="dropdown-1"
              text="ประเภทการส่ง"
              variant="secondary"
              class="m-auto"
            >
              <b-form-group>
                <b-form-checkbox
                  v-for="x in contactType.filter((s) =>
                    [1, 2, 3, 4].includes(s.id)
                  )"
                  :key="x.id"
                  v-model="filter.contact_type_id"
                  :value="x.id"
                  name="contact-type-filter"
                  stacked
                  class="mx-3 my-2"
                >
                  {{ x.type_name }}
                </b-form-checkbox>
              </b-form-group>
            </b-dropdown>
          </b-col>
          <b-col cols="auto" class="px-1px my-1">
            <b-dropdown
              id="dropdown-1"
              text="สถานะ"
              variant="secondary"
              class="m-auto"
            >
              <b-form-group>
                <b-form-checkbox
                  v-for="x in status.filter((s) =>
                    [2, 3, 4, 5, 6, 7, 8].includes(s.id)
                  )"
                  :key="x.id"
                  v-model="filter.status_id"
                  :value="x.id"
                  name="status-filter"
                  stacked
                  class="mx-3 my-2"
                >
                  {{ x.meaning }}
                </b-form-checkbox>
              </b-form-group>
            </b-dropdown>
          </b-col>
          <b-col cols="auto" class="px-1px my-1">
            <b-dropdown
              id="dropdown-1"
              text="ประเภท Lab"
              variant="secondary"
              class="m-auto"
            >
              <b-form-group>
                <b-form-checkbox
                  v-for="x in outLabList"
                  :key="x.name"
                  v-model="filter.is_out_lab"
                  :value="x.value"
                  name="out-lab-filter"
                  stacked
                  class="mx-3 my-2"
                >
                  {{ x.name }}
                </b-form-checkbox>
              </b-form-group>
            </b-dropdown>
          </b-col>
          <b-col cols="auto" class="px-1px my-1">
            <b-dropdown
              id="dropdown-1"
              text="Test Type"
              variant="secondary"
              class="m-auto"
            >
              <b-form-group>
                <b-form-checkbox
                  v-for="x in testTypes"
                  :key="x.name"
                  v-model="filter.test_type"
                  :value="x.id"
                  name="test-type-filter"
                  stacked
                  class="mx-3 my-2"
                  >{{ x.name }}</b-form-checkbox
                >
              </b-form-group>
            </b-dropdown>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="p-2" cols="12">
            <b-button
              size="lg"
              class="cover-btn all btn-block"
              @click="printSummaryHandlerModal(filter)"
            >
              พิมพ์
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </b-container>
</template>

<script>
import printJS from "print-js";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import format from "date-fns/format";

export default {
  name: "SummaryReportModal",
  props: {
    statusPrint: {
      type: Array,
      default: () => {
        return [];
      },
    },
    printSummaryHandler: {
      type: Function,
      default: () => {
        return false;
      },
    },
    statusShared: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      filter: {
        dateOne: null,
        dateTwo: null,
        dateRange: [],
        is_printed: ["print", "notPrint"],
        is_shared: ["shared", "notShared"],
        status_id: [2, 3, 4, 5, 6, 7, 8],
        is_out_lab: ["inLab", "outLab", "null"],
        contact_type_id: [1, 2, 3, 4],
        test_type: [],
      },
      dateFormat: "D/MM/YYYY",
      isLoading: false,
      activeCloseDate: false,
      outLabList: [
        { name: "In Lab", value: "inLab" },
        { name: "Out Lab", value: "outLab" },
        { name: "ไม่ระบุ", value: "null" },
      ],
    };
  },
  created() {
    var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
    this.filter.dateOne = today;
    this.filter.dateTwo = today;

    var todayRange = moment.tz("Asia/Bangkok");
    this.filter.dateRange = [
      todayRange
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0)
        .toDate(),
      todayRange
        .set("hour", 23)
        .set("minute", 59)
        .set("second", 59)
        .toDate(),
    ];
  },
  mounted() {
    this.outLabList = [
      ...this.outLabList,
      // ...this.testTypes.map((testType) => ({
      //   name: testType.name,
      //   value: testType.id,
      // })),
    ];
    this.filter.test_type = [...this.testTypes.map((testType) => testType.id)];
  },
  computed: {
    ...mapGetters({
      status: "Status/getAll",
      contactType: "ContactType/getAll",
      testTypes: "Test/getTestType",
    }),
  },
  methods: {
    ...mapActions({}),
    async coverPrintHandler() {},
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    clearDate() {
      this.filter.dateOne = "";
      this.filter.dateTwo = "";
    },
    printSummaryHandlerModal(filter) {
      this.printSummaryHandler(filter);
    },
    async permission(type, mod) {
      let permission = await this.checkPermission({
        type: type,
        mod: mod,
      });

      if (!permission) {
        this.$notify({
          group: "alert",
          title: "มีข้อผิดพลาดบางอย่าง",
          text: permission,
          position: "bottom right",
          type: "error",
        });
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.cover-print-btn {
  background-color: #fb822b;
  border: none;
}
.cover-btn {
  border-radius: 0;
  border: none;
  &.distance {
    background: #fb822b;
    &:hover {
      background: #944a1c;
    }
  }
  &.corporation {
    background: #2e83d9;
    &:hover {
      background: #1f4a83;
    }
  }
  &.all {
    background: indianred;
    &:hover {
      background: #753737;
    }
  }
}

.form-select {
  // height: 15rem;
  border: 1px solid black;
  padding: 1rem;
  margin: 1rem;
  text-align: center;
  // opacity: 0.1;
  &.select {
    background: #fb822b;
    color: white;
  }
}
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
.col {
  padding-right: 2px;
  padding-left: 2px;
}
</style>
